import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { img } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";
import { VIDEOS, bigThumb, fallback } from "@/pages/About";
import { useLang } from "@/lib/i18n";

export const MeetBlue = ({ photo }) => {
  const { t, to } = useLang();
  return (
    <section className="container-x py-16 sm:py-20" data-testid="home-meet-blue">
      <Reveal className="grid items-center gap-8 overflow-hidden rounded-3xl bg-forest text-white sm:grid-cols-5">
        <img src={photo ? img(photo) : bigThumb(VIDEOS[0])} onError={photo ? undefined : fallback(VIDEOS[0])} alt="Blue — Heather Anne van Doorninck, Escamequita"
          loading="lazy" className="h-80 w-full object-cover object-[50%_40%] sm:col-span-2 sm:h-[440px]" data-testid="meet-blue-photo" />
        <div className="p-8 pt-0 sm:col-span-3 sm:p-12 sm:pl-4">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-sand">{t("meet.eyebrow")}</p>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-white sm:text-4xl">{t("meet.title")}</h2>
          <p className="mt-4 max-w-xl font-medium leading-relaxed text-white/85">{t("meet.text")}</p>
          <Link to={to("/about")} className="btn-primary mt-7 !bg-white !text-forest hover:!bg-sand" data-testid="meet-blue-cta">{t("meet.cta")} <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </Reveal>
    </section>
  );
};
